// extracted by mini-css-extract-plugin
module.exports = {"requestBox":"style_request-box__S7U43","mainAdornment":"style_main-adornment__dqYZn","mainImage":"style_main-image__FXQNW","imageAdornment":"style_image-adornment__VRyCc"};